import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { QueryClient } from '@tanstack/react-query'
import { removeOldestQuery } from '@tanstack/react-query-persist-client'
import throttle from 'lodash/throttle'

export interface CustomQueryMeta {
  persist?: boolean
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 1000,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true
    }
  }
})

export const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  retry: removeOldestQuery,
  throttleTime: 100, // 100ms
  serialize: (data: any) => {
    data.clientState.queries = data.clientState.queries.filter(
      (query: any) => (query.meta as CustomQueryMeta)?.persist !== false
    )
    return JSON.stringify(data)
  }
})

export class QueryKeys {
  public static Sessions = ['Sessions']
  public static User = ['User']
  public static UserAppConfig = ['UserAppConfig']
  public static FeatureFlags = ['FeatureFlags']
  public static Conversations = ['Conversations']
  public static Organizations = ['Organizations']
  public static Indexes = ['Indexes']
  public static AnnotationTasks = ['AnnotationTasks']
  public static MfaCode = ['MfaCode']
  public static FlowNames = ['FlowNames']
  public static AccessLogs = ['AccessLogs']
  public static EDITransactionCodes = ['EDITransactionCodes']
  public static EDIFactCodes = ['EDIFactCodes']
  public static AdminConversationsList = ['AdminConversationsList']
  public static AdminTasksList = ['AdminTasksList']
  public static AdminUsageEvents = ['AdminUsageEvents']
  public static AdminUsageEventsFacets = (days: number) => ['AdminUsageEventsFacets', days]
  public static ConnectionMetadata = ['ConnectionMetadata']
  public static ConnectionStatus = ['ConnectionStatus']
  public static TaskDetails = (conversationUuid?: string, taskId?: string) => [
    'TaskDetails',
    conversationUuid,
    taskId
  ]
  public static UsageDashboard = ['UsageDashboard']
}

export const throttedInvalidateConversations = throttle(() => {
  return queryClient.invalidateQueries(
    { queryKey: QueryKeys.Conversations },
    { cancelRefetch: true }
  )
}, 500)
